import React, { useState } from "react";
import { Link } from "react-router-dom";
import UnauthorizedAccess from "../../pages/UnauthorizedAccess/UnauthorizedAccess";

export default function Error() {
  const [isError, setError] = useState(false);
  const pages = [
    "User",
    "NonStandardMLFB",
    "ZCodeMaster",
    "StandardMLFB",
    "StandardMLFBBulkUpload",
    "PriceList",
    "UploadDrawing",
    "Quotation",
  ];

  const currentUrl = window.location.href;
  const lastPart = currentUrl.split("/").filter(Boolean).pop();

  return (
    <>
      {(pages.includes(lastPart)) ? (
      <UnauthorizedAccess />
      ) : (
        
        <div>
        <h2 style={{ textAlign: "left" }}>
          This is Error 404. Possibly you landed on unknown URL
        </h2>
        <h4>
          Please click{" "}
          <Link to="/" className="clr-white">
            here
          </Link>{" "}
          to go back to homepage.
        </h4>
      </div>
      )}
    </>
  );
}
